import { getMonitorWatcher } from './monitor.saga';
import { getHydrateStateWatcher } from './hydrate-state.saga';

export default [
  getMonitorWatcher(),
  getHydrateStateWatcher(),
];
